let girls = [
  {
    _id: "674a36912682b819b1fbea25",
    fullName: "Карина",
    nationality: "RUSSIAN",
    appearance: "SLAVENIAN",
    age: 22,
    boobsSize: 1,
    height: 159,
    weight: 50,
    place: "ME",
    oneHourPrice: 8200,
    twoHourPrice: 16000,
    nightPrice: 36000,
    description:
      "Меня можно охарактеризовать несколькими словами: я похотливая девчонка и согласна на любые эксперименты для достижения обоюдного оргазма в постели))",
    cityGroupId: "674cda5c234d2c0dcb2752c1",
    workerCity: null,
    preference: [
      {
        _id: "674a5343db6800e93e66aa15",
        name: "Фетиш",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9fa",
        name: "Кунилинус",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa0b",
        name: "Фистинг анальный клиенту",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9fe",
        name: "Окончание на лицо",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa17",
        name: "Шибари",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa16",
        name: "Трамлинг",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f1",
        name: "Секс анальный",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa25",
        name: "Секс по телефону",
        category: "ETC",
        __v: 0,
      },
    ],
    slut: true,
    individual: false,
    escort: false,
    __v: 1,
    photos: [
      {
        _id: "674a36912682b819b1fbea27",
        girlId: "674a36912682b819b1fbea25",
        url: "https://cdn.xxximageur.com/f/UDJO4NbyQxBaTQjRj1grHw.jpg",
        __v: 0,
      }
    ],
  },
  {
    _id: "674a36932682b819b1fbea4d",
    fullName: "Дарья",
    nationality: "UKRAINIAN",
    appearance: "SLAVENIAN",
    age: 20,
    boobsSize: 5,
    height: 161,
    weight: 52,
    place: "YOU",
    oneHourPrice: 6400,
    twoHourPrice: 12800,
    nightPrice: 39600,
    description:
      "Обворожительная и сногсшибательная, ласковая и нежная! Всегда готова для приятных и весёлых встреч...",
    cityGroupId: "674cda5c234d2c0dcb2752c1",
    workerCity: null,
    preference: [
      {
        _id: "674a5343db6800e93e66aa0f",
        name: "Госпожа",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa1f",
        name: "Лесби-шоу легкое",
        category: "STRIPTEASE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa0c",
        name: "Фистинг анальный мне",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa03",
        name: "Массаж урологический",
        category: "MASSAGE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa07",
        name: "Анилингус клиенту",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa29",
        name: "Клизма",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa19",
        name: "Копро (выдача)",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa22",
        name: "Ролевые игры",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f5",
        name: "Минет в резинке",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa04",
        name: "Массаж эротический",
        category: "MASSAGE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa13",
        name: "Бондаж",
        category: "BDSM",
        __v: 0,
      },
    ],
    slut: false,
    individual: true,
    escort: true,
    __v: 1,
    photos: [
      {
        _id: "674a36932682b819b1fbea4f",
        girlId: "674a36932682b819b1fbea4d",
        url: "https://cdn.xxximageur.com/f/M_Zj7JSGX5vPFYBFwg5JIQ.jpg",
        __v: 0,
      }
    ],
  },
  {
    _id: "674a36992682b819b1fbeac5",
    fullName: "Настя",
    nationality: "RUSSIAN",
    appearance: "ASIAN",
    age: 20,
    boobsSize: 1,
    height: 152,
    weight: 40,
    place: "YOU",
    oneHourPrice: 7100,
    twoHourPrice: 13800,
    nightPrice: 45100,
    description: "Молодая, гибкая, красивая, приятная в общении",
    cityGroupId: "674cda5c234d2c0dcb2752c1",
    workerCity: null,
    preference: [
      {
        _id: "674a5343db6800e93e66aa23",
        name: "Фото/видео съемка",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f6",
        name: "Минет без резинки",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa27",
        name: "Есть шенген",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa06",
        name: "Страпон",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa12",
        name: "Подчинение",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa11",
        name: "Рабыня",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa0c",
        name: "Фистинг анальный мне",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa24",
        name: "Виртуальный секс",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9fb",
        name: "Целуюсь",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f8",
        name: "Минет горловой",
        category: "SEX",
        __v: 0,
      },
    ],
    slut: true,
    individual: false,
    escort: true,
    __v: 1,
    photos: [
      {
        _id: "674a369a2682b819b1fbeac7",
        girlId: "674a36992682b819b1fbeac5",
        url: "https://cdn.xxximageur.com/f/aeanAThhY551OMPWs1fY1Q.jpg",
        __v: 0,
      }
    ],
  },
  {
    _id: "674a369f2682b819b1fbeb39",
    fullName: "Карина ",
    nationality: "AZERBAIJANIAN",
    appearance: "ASIAN",
    age: 20,
    boobsSize: 2,
    height: 165,
    weight: 53,
    place: "ME",
    oneHourPrice: 4600,
    twoHourPrice: 8900,
    nightPrice: 49500,
    description:
      "Рост: 168, Вес: 51, Размер груди, Цвет волос: блонд, Место встречи: (выезд или у меня)",
    cityGroupId: "674cda5c234d2c0dcb2752c1",
    workerCity: null,
    preference: [
      {
        _id: "674a5343db6800e93e66a9f0",
        name: "Секс классический",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f9",
        name: "Минет в машине",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9ff",
        name: "Окончание в рот",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa23",
        name: "Фото/видео съемка",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa14",
        name: "Порка",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa05",
        name: "Массаж семейной паре",
        category: "MASSAGE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa1d",
        name: "Стриптиз не профи",
        category: "STRIPTEASE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f8",
        name: "Минет горловой",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa27",
        name: "Есть шенген",
        category: "ETC",
        __v: 0,
      },
    ],
    slut: false,
    individual: true,
    escort: false,
    __v: 1,
    photos: [
      {
        _id: "674a36a02682b819b1fbeb3b",
        girlId: "674a369f2682b819b1fbeb39",
        url: "https://cdn.xxximageur.com/f/mG7BVr5Pq08p_PQ99r-TMQ.jpg",
        __v: 0,
      }
    ],
  },
  {
    _id: "674a36a52682b819b1fbeba5",
    fullName: "Кристина ",
    nationality: "AZERBAIJANIAN",
    appearance: "SLAVENIAN",
    age: 24,
    boobsSize: 3,
    height: 159,
    weight: 51,
    place: "ME",
    oneHourPrice: 9700,
    twoHourPrice: 18800,
    nightPrice: 21300,
    description: "Молодая, гибкая, красивая",
    cityGroupId: "674cda5c234d2c0dcb2752c1",
    workerCity: null,
    preference: [
      {
        _id: "674a5343db6800e93e66aa1e",
        name: "Лесби откровенное",
        category: "STRIPTEASE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa08",
        name: "Анилингус мне",
        category: "EXTREME",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa00",
        name: "Поза 69",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa1b",
        name: "Сквирт",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa19",
        name: "Копро (выдача)",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa01",
        name: "Массаж классический",
        category: "MASSAGE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa1f",
        name: "Лесби-шоу легкое",
        category: "STRIPTEASE",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa21",
        name: "Сопровождение",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66a9f3",
        name: "Секс лесбийский",
        category: "SEX",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa1a",
        name: "Копро (прием)",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa27",
        name: "Есть шенген",
        category: "ETC",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa11",
        name: "Рабыня",
        category: "BDSM",
        __v: 0,
      },
      {
        _id: "674a5343db6800e93e66aa18",
        name: "Фейсситтинг",
        category: "BDSM",
        __v: 0,
      },
    ],
    slut: false,
    individual: false,
    escort: false,
    __v: 1,
    photos: [
      {
        _id: "674a36a52682b819b1fbeba7",
        girlId: "674a36a52682b819b1fbeba5",
        url: "https://cdn.xxximageur.com/f/B701Im4y8X3dYApcfMJ3fw.jpg",
        __v: 0,
      },
    ],
  },
];

export default girls;
